import type { Dispatch, SubmitEvent, SetStateAction } from 'react';
import { useEffect, useState } from 'react';
import styles from './FindSubscribers.module.css';
import Button from '@standardsdigital/ui-components/Button';
import type { SubscriberModel } from 'redux/services/api.generated';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import SubscriberList from 'components/pages/Subscriptions/SubscriberList/SubscriberList';
import TextInput from '@standardsdigital/ui-components/TextInput';
import { routes } from 'util/routes';

interface FindSubscribersProps {
  setSelectedSubscriber: Dispatch<SetStateAction<SubscriberModel | undefined>>;
  selectedSubscriber: SubscriberModel | undefined;
  className?: string;
}

const searchKey = routes.subscribersSearch.searchParams.q;

function FindSubscribers({
  setSelectedSubscriber,
  selectedSubscriber,
  className,
}: Readonly<FindSubscribersProps>) {
  const { t } = useTranslation();

  const [searchParams, setSearchParams] = useSearchParams();
  const [inputValue, setInputValue] = useState(searchParams.get(searchKey) || '');
  const [value, setValue] = useState(searchParams.get(searchKey));
  const [page, setPage] = useState(0);

  useEffect(() => {
    setSearchParams({ [searchKey]: value || '' });
  }, [setSearchParams, value]);

  const handleSubmit = (event: SubmitEvent<HTMLFormElement>) => {
    event.preventDefault();
    setValue(inputValue);
    setPage(0);
    setSelectedSubscriber(undefined);
  };

  return (
    <article className={`${styles.findSubscribers} ${className || ''}`}>
      <h2 className={`sd-heading-md ${styles.heading}`}>
        {t('subscribers.subscribers')}
      </h2>
      <form
        onSubmit={handleSubmit}
        className={`${styles.form} sd-search-box`}
        aria-label={t('subscribers.filterSubscribers')}
      >
        <TextInput
          label={t('subscribers.filterSubscribers')}
          id="subscribers"
          name="subscribers"
          type="search"
          clearButtonProps={{ text: t('general.clearSearch') }}
          onChange={(event) => setInputValue(event.target.value)}
          className={styles.searchInput}
          placeholder={t('subscribers.organizationNameOrId')}
          value={inputValue}
        />
        <Button type="submit" variant="primary" className={styles.searchButton}>
          {t('general.search')}
        </Button>
      </form>
      <SubscriberList
        selectedSubscriber={selectedSubscriber}
        setSelectedSubscriber={setSelectedSubscriber}
        page={page}
        setPage={setPage}
        inputValue={value}
      />
    </article>
  );
}

export default FindSubscribers;
